import { render, staticRenderFns } from "./BlockedDays.vue?vue&type=template&id=2bc97ae4&scoped=true&"
import script from "./BlockedDays.vue?vue&type=script&lang=js&"
export * from "./BlockedDays.vue?vue&type=script&lang=js&"
import style0 from "./BlockedDays.vue?vue&type=style&index=0&id=2bc97ae4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc97ae4",
  null
  
)

export default component.exports